<template>
  <div
    v-if="selected"
    ref="annual-plan"
    class="annual-plan"
  >
    <plan-header
      class="plan-header"
      :title="selected.plan.name"
      :salary="selected.employee.salary"
      :dates="selected.plan.dates"
      :message="summary_message"
      :is-eos="!!selected.plan.isEos"
      :finalized="finalized"
    />
    <plan-toolbar
      class="plan-toolbar"
      :date="selected.plan.dates.statement"
      :pdf="selected.pdf_link"
      :spd="selected.spd_link"
    />
    <plan-overview
      class="plan-overview"
      :selected="selected"
    />
    <plan-scale
      class="plan-scale"
      :selected="selected"
    />
    <plan-calculation :selected="selected" />
    <plan-summary
      :summary="selected.plan.summary"
      :individual="selected.employee"
      :organization="selected.organization"
      :plan="selected.plan"
      :distributions="selected.distributions"
      :allocations="selected.allocation_pools"
      :forecast="selected.forecast"
    />
  </div>
</template>

<script>
import PlanHeader from "@/components/plans/short-term/PlanHeader.vue";
import PlanToolbar from "@/components/plans/global/PlanToolbar.vue";
import PlanOverview from "@/components/plans/short-term/PlanOverview.vue";
import PlanScale from "@/components/plans/short-term/scale/PlanScale.vue";
import PlanCalculation from "@/components/plans/short-term/calculation/PlanCalculation.vue";
import PlanSummary from "@/components/plans/short-term/summary/PlanSummary.vue";
import UtilsMixin from "@/mixins/UtilsMixin";
import ColorsMixin from "@/mixins/ColorsMixin";

export default {
    name: "ShortTermPlanView",

    components: {
        PlanSummary,
        PlanHeader,
        PlanToolbar,
        PlanOverview,
        PlanScale,
        PlanCalculation,
    },

    mixins: [ UtilsMixin, ColorsMixin ],

    props: {
        plan: {
            type: Object,
            required: true,
        },
        finalized: {
          type: Boolean,
          default: false
        }
    },

    data() {
        return {
            selected: null,
        }
    },

    computed: {
        current() {
            return this.plan?.current
        },
        previous() {
            return this.plan?.previous
        },
        summary_message() {
          return this.current?.summary_message
        },
    },

    watch: {},

    mounted() {
        this.selected = this.plan?.current.statement_data
    },

    methods: {},
}
</script>

<style lang="scss" scoped>
@use "../../scss/_variables.scss";

.annual-plan {
    .h1, .h2, .h3, .h4, .h5, .h6, div, p, span {
        color: variables.$charcoal;
    }
}

.plan-overview {
    margin-bottom: 1.125rem;
}

.plan-scale {
    margin-bottom: 4.2667rem;
}
</style>